module.exports = __webpack_public_path__ + "img/ganzhi.fac8d23a.png";